import { design, FieldCheckBoxFactory, IconFactory } from '@webnuts/components'

const COLORS = {
  grey: {
    '100': '#FAFAFA',
    '200': '#E0E0E0',
    '300': '#C6C6C6',
    '400': '#ACACAC',
    '500': '#929292',
    '600': '#717171',
    '700': '#515151',
    '800': '#303030',
    '900': '#171717'
  },

  onLight: {
    500: '#303030'
  },

  onDark: {
    500: '#ffffff'
  },

  blue: {
    500: '#56A0D3',
    700: '#428CBF'
  },

  errorRed: {
    500: '#E16868',
    600: '#F24638'
  }
} as const

export const { FieldCheckBox, Icon, IconLarge } = design([FieldCheckBoxFactory, IconFactory], {
  Icon: {
    default: {
      size: '11px'
    },

    IconLarge: {
      size: '16px'
    }
  },

  FieldCheckBox: {
    default: {
      label: {
        placement: 'right',
        align: 'center',
        spacing: '8px',
        font: { family: "'Roboto', sans-serif", size: '14px', lineHeight: '17px' },
        palette: { text: COLORS.onLight[500] }
      },
      error: {
        spacing: '4px',
        font: { family: "'Roboto', sans-serif", size: '12px' },
        palette: { text: COLORS.errorRed[600] }
      },
      checkbox: {
        size: '16px',
        border: {
          width: '1px',
          radius: {
            bottomLeft: '2px',
            bottomRight: '2px',
            topLeft: '2px',
            topRight: '2px'
          }
        },
        palette: {
          check: 'transparent',
          background: 'white',
          border: COLORS.grey[800]
        }
      },
      $when: {
        focus: {
          checkbox: {
            palette: { border: COLORS.blue[700] }
          }
        },
        hover: {
          checkbox: {
            palette: { border: COLORS.blue[700] }
          }
        },
        checked: {
          checkbox: {
            palette: {
              border: COLORS.blue[500],
              background: COLORS.blue[500],
              check: 'white'
            }
          }
        },
        readonly: {
          checkbox: {
            palette: {
              border: COLORS.grey[200],
              check: COLORS.grey[500],
              background: COLORS.grey[100]
            }
          }
        },
        invalid: {
          checkbox: {
            palette: {
              check: COLORS.errorRed[500],
              border: COLORS.errorRed[500]
            }
          }
        },
        disabled: {
          checkbox: {
            palette: {
              border: COLORS.grey[200],
              check: COLORS.onLight[500],
              background: COLORS.grey[100]
            }
          }
        }
      }
    }
  }
} as const)
